import { Typography } from "@mui/material";
import React from "react";
import { stepOneData } from "../stepsData";
import {
  paragraphStyle,
  paragraphStyleOL,
  paragraphStyleUL,
} from "../../../../calculatorStyleData";
import tongueOut from "../../../../../Assets/Images/tongue-out.webp";

const StepOne = () => {
  return (
    <>
      <div id="step_one_data" className="mt-3">
        <div>
          <Typography
            sx={{
              fontFamily: "'Archivo', sans-serif",
              fontSize: "16px",
              letterSpacing: "normal",
              lineHeight: "24px",
            }}
          >
            Managing personal loans can be stressful, especially if you are
            paying high-interest rates. MinEMI’s{" "}
            <strong>Personal Loan Balance Transfer EMI Calculator</strong> helps
            you reduce your financial burden by calculating potential savings
            when you transfer your personal loan to a lender offering better
            terms. Use this tool to plan your monthly EMIs, compare lenders, and
            take control of your finances.
          </Typography>
        </div>
        <div id="list-data">
          <div className=" d-flex flex-column mt-3 ">
            {/* heading */}
            <Typography
              sx={{
                fontSize: "24px",
                lineHeight: "32px",
                letterSpacing: "0.08px",
                textAlign: "start",
                fontFamily: "'Archivo', sans-serif",
                color: "#1F1F1F",
                fontWeight: 700,
              }}
            >
              {stepOneData[0].heading}
            </Typography>
          </div>
          <div id="list_data_content" className=" d-flex flex-column mt-2">
            <ol style={paragraphStyleOL}>
              {stepOneData[0].infoList &&
                stepOneData[0].infoList.map((item, index) => (
                  <li className="mt-2">
                    {" "}
                    <strong>{item.heading}</strong>
                    {item.description}
                  </li>
                ))}
            </ol>
          </div>
        </div>
        <div id="list-data_two">
          <div className=" d-flex flex-column mt-1 ">
            {/* heading */}
            <Typography
              sx={{
                fontSize: "24px",
                lineHeight: "32px",
                letterSpacing: "0.08px",
                textAlign: "start",
                fontFamily: "'Archivo', sans-serif",
                color: "#1F1F1F",
                fontWeight: 700,
              }}
            >
              {stepOneData[0].headingTwo}
            </Typography>
          </div>
          <div id="list_data_content" className=" d-flex flex-column mt-2">
            <ol style={paragraphStyleOL}>
              {stepOneData[0].infoListTwo &&
                stepOneData[0].infoListTwo.map((item, index) => (
                  <li className="mt-2">
                    <strong>{item.heading}</strong>
                    {item.description}
                  </li>
                ))}
            </ol>
          </div>
        </div>
        <div className="tips mt-3">
          <div id="border_line"></div>
          <div id="tip__container" className="px-2 px-sm-4 py-4">
            <div className="px-3 py-2">
              <div className="d-flex flex-row gap-2 align-items-center">
                <img
                  src={tongueOut}
                  alt="minemiTip-image"
                  style={{ width: 30, height: 30 }}
                />
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#59266D",
                    // color: "yellow",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  MinEmi Tip
                </Typography>
              </div>
              <div className="mt-2">
                <ul style={paragraphStyleUL}>
                  {stepOneData[0].minemiTip &&
                    stepOneData[0].minemiTip.map((item) => (
                      <li>{item.info}</li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StepOne;
